import React, { FunctionComponent } from 'react'
import { BASE_PATH } from '../../env'
import styles from './style.module.css'
import Image from 'next/image'
import { Theme, useGetSelectedTheme } from '@afterpaytouch/core'
import { Illustration, ILLUSTRATIONS } from '../Illustration'

export const BiometricAnimation: FunctionComponent = () => {
  const theme = useGetSelectedTheme()

  const faceSvgSrc = [BASE_PATH, 'images/biometric/face.svg'].join('/')
  const fingerprintSvgSrc = [BASE_PATH, 'images/biometric/fingerprint.svg'].join('/')
  const tickSvgSrc = [BASE_PATH, 'images/biometric/tick.svg'].join('/')

  if (theme !== Theme.AP) {
    return <Illustration name={ILLUSTRATIONS.EyeRecognition} alt='eye-id' width={249} height={119} />
  }

  return (
    <div className={styles.animation}>
      <div className={styles.face}>
        <Image
          src={faceSvgSrc}
          alt='face-id'
          width='75'
          height='75'
          style={{
            maxWidth: '100%',
            height: 'auto',
          }}
        />
      </div>
      <div className={styles.fingerprint}>
        <Image
          src={fingerprintSvgSrc}
          alt='fingerprint'
          width='75'
          height='75'
          style={{
            maxWidth: '100%',
            height: 'auto',
          }}
        />
      </div>
      <div className={styles.tick}>
        <Image
          src={tickSvgSrc}
          alt=''
          width='75'
          height='75'
          style={{
            maxWidth: '100%',
            height: 'auto',
          }}
        />
      </div>
    </div>
  )
}
